import { MediaMeta, MediaType } from '@/pages/mediaManager'
import { faMusic, faFilePdf, faImage, faVideo } from '@fortawesome/free-solid-svg-icons'

export function matchMediaIcon(type: MediaMeta['type']) {
	switch (type) {
		case MediaType.Audio: return faMusic
		case MediaType.Pdf: return faFilePdf
		case MediaType.Image: return faImage
		case MediaType.Video: return faVideo
	}
}
